<template>
  <div>
    <div class="topbar">
      <div class="brand" @click="$router.back()">&#8249; 我的订单</div>
    </div>
    <div class="content">
      <div class="order-tabs">
        <div
          v-for="t in tabs"
          :key="t.key"
          class="order-tab"
          :class="{ active: currentTab === t.key }"
          @click="currentTab = t.key"
        >
          {{ t.label }}
          <span class="tab-count" v-if="t.key !== 'all'">{{ counts[t.key] || 0 }}</span>
        </div>
      </div>

      <div v-if="!filteredOrders.length" class="empty">
        <div class="empty-icon">📋</div>
        <div>{{ currentTab === "all" ? "还没有订单" : "该状态下暂无订单" }}</div>
        <div class="empty-action">
          <span class="btn sm" @click="$router.push('/home')">去找科研专家</span>
        </div>
      </div>

      <div
        v-for="o in filteredOrders"
        :key="o.id"
        class="card tap"
        @click="$router.push('/order/' + o.id)"
      >
        <div class="row">
          <div style="font-weight: 600">{{ o.slotTitle }}</div>
          <span class="status" :class="statusKey(o.orderStatus)">{{
            statusText(o.orderStatus)
          }}</span>
        </div>
        <div class="muted" style="margin-top: 4px">
          {{ o.expertName }} · ¥{{ (o.orderTotalAmount / 100).toLocaleString("zh-CN") }}
        </div>
        <div class="order-meta">
          <div>订单号：{{ o.orderNo }}</div>
          <div>生成时间：{{ o.createTime }}</div>
          <div v-if="o.orderPayTime">支付时间：{{ o.orderPayTime }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderList } from "@/api/nrc.js";

const STATUS_KEY_MAP = {
  0: "pending",
  1: "paid",
  2: "paid",
  3: "delivered",
  4: "reviewed",
  5: "refunded",
  98: "closed",
  99: "closed",
};
const STATUS_TEXT_MAP = {
  pending: "待支付",
  paid: "待交付",
  delivered: "已交付",
  reviewed: "已完成",
  refunded: "已退款",
  closed: "已关闭",
};

export default {
  name: "MyOrders",
  data() {
    return {
      orders: [],
      currentTab: "all",
      tabs: [
        { key: "all", label: "全部" },
        { key: "pending", label: "待支付" },
        { key: "paid", label: "待交付" },
        { key: "delivered", label: "已交付" },
        { key: "reviewed", label: "已完成" },
        { key: "refunded", label: "已退款" },
      ],
    };
  },
  computed: {
    counts() {
      let c = {};
      this.orders.forEach((o) => {
        let key = statusKey(o.orderStatus);
        c[key] = (c[key] || 0) + 1;
      });
      return c;
    },
    filteredOrders() {
      if (this.currentTab === "all") return this.orders;
      return this.orders.filter((o) => statusKey(o.orderStatus) === this.currentTab);
    },
  },
  created() {
    orderList().then((r) => {
      this.orders = r;
    });
  },
  methods: {
    statusKey,
    statusText(status) {
      return STATUS_TEXT_MAP[statusKey(status)] || "--";
    },
  },
};

function statusKey(status) {
  return STATUS_KEY_MAP[status] || "closed";
}
</script>
